import React, { Fragment, useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CardBody, Col, Form, FormGroup, Label, ModalFooter, Row } from "reactstrap";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { RootState } from "../../../../store";
import StepperActionButtons from "../../../stepper-action-button/stepperActionButton";
import { translate } from "react-switch-lang";
import styles from "./stepOne.module.scss";

const StepOne = (props: any) => {
  toast.configure();
  let documentRef = React.useRef(null);
  let langueRef = React.useRef(null);
  let thematicRef = React.useRef(null);
  let countryRef = React.useRef(null);
  const httpClient = useHttpClient(true);
  const path = "/Mediatheque/image/";
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [listOptionsCountry, setListOptionsCountry] = useState([]);
  const [listOptionsVideo, setListOptionsVideo] = useState([]);
  const [isFormValid, setIsFomrValid] = useState(false);
  const [isOnUpdate, setisOnUpdate] = useState(false);
  const [listOptionsLanguage] = useState([{ name: "Français" }, { name: "Anglais" }, { name: "Autre" }]);
  const [listOptionsThematic, setListOptionsThematic] = useState([]);
  const [selectedSupport] = useState<any>(null);
  const [isShowDropZone, setIsShowDropZone] = useState(true);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      dateSupport: props?.support?.dateSupport ? props.support.dateSupport : "",
      title: props.support?.title ? props.support.title : "",
      language: props.support?.language ? props.support.language : "",
      videoTypeId: props.support?.videoTypeId ? props.support.videoTypeId : 0,
      listThematic: props.support?.listThematic ? props.support.listThematic : [],
      listCountry: props.support?.listCountry ? props.support.listCountry : [],
    },
  });
  useEffect(() => {
    if (props.support) {
      setIsFomrValid(true);
      setisOnUpdate(true);
      if (props.support.urlSupport) {
        setIsShowDropZone(false);
      }
      setValue("dateSupport", props.support?.dateSupport);
    }

    httpClient.current?.get("/video_type").then(response => {
      setListOptionsVideo(response.data);
    });
    httpClient.current?.get("/thematic").then(response => {
      setListOptionsThematic(response.data);
    });
    httpClient.current?.get("/country").then(response => {
      setListOptionsCountry(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const handleIsFormValid = element => {
    setIsFomrValid(
      getValues().title !== "" &&
        getValues().listCountry.length !== 0 &&
        getValues().listThematic.length !== 0 &&
        getValues().language !== "" &&
        getValues().videoTypeId !== 0 &&
        getValues().dateSupport !== "",
    );
  };
  const handleChangeDocument = (selectedOptions: any) => {
    clearErrors("title");
    clearErrors("videoTypeId");
    if (selectedOptions.length === 1) {
      setValue("videoTypeId", selectedOptions[0].videoTypeId);
      handleIsFormValid(selectedOptions);
    } else {
      setValue("videoTypeId", 0);
      handleIsFormValid(selectedOptions);
    }
  };

  const handleChangeLanguage = selectedOptions => {
    clearErrors("language");
    if (selectedOptions.length === 1) {
      setValue("language", selectedOptions[0].name);
      handleIsFormValid(selectedOptions);
    } else {
      setValue("language", "");
      handleIsFormValid(selectedOptions);
    }
  };

  const handleChangeThematic = selectedOptions => {
    clearErrors("listThematic");
    setValue("listThematic", selectedOptions);
    handleIsFormValid(selectedOptions);
  };

  const handleChangeCountry = selectedOptions => {
    clearErrors("listCountry");
    setValue("listCountry", selectedOptions);
    handleIsFormValid(selectedOptions);
  };

  const onSubmit = data => {
    if (!isOnUpdate) {
      let formData = new FormData();
      data.categoryId = props.categoryId;
      if (selectedSupport) {
        formData = new FormData();
        formData.append("file", selectedSupport);
        httpClient.current
          ?.post(`/support/files?path=${path}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(response => {
            data.pathSupport = response.data;
            httpClient.current?.post("/support_video", data).then(response => {
              toast.success(props.t("message_toastr_add_video"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
              props.getListSupport();
              props.closeToggle();
            });
          });
      } else {
        httpClient.current?.post("/support_video", data).then(response => {
          toast.success(props.t("message_toastr_add_video"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          props.getListSupport();
          props.closeToggle();
        });
      }
    } else {
      hanldeUpdateSupport(data);
    }
  };

  const hanldeUpdateSupport = support => {
    support.supportId = props.support.supportId;
    support.pathSupport = props.support.pathSupport;
    support.urlSupport = props.support.urlSupport;
    support.categoryId = props.support.categoryId;
    support.supportVideoESId = props.support.supportVideoESId;
    let formData = new FormData();
    if (selectedSupport) {
      formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/support/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          support.pathSupport = response.data;
          httpClient.current?.put("/support_video", support).then(response => {
            props.getListSupport();
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.getListSupport();
            props.closeToggle();
          });
        });
    } else {
      if (isShowDropZone) {
        support.pathSupport = "";
        support.urlSupport = "";
      }
      httpClient.current?.put("/support_video", support).then(response => {
        props.closeToggle();
        toast.success(props.t("message_toastr_update"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
        props.getListSupport();
      });
    }
  };

  const validate = () => {
    props.nextStep();
    props.userCallback(getValues());
  };
  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)} className={styles["step-one_form-add-video"] + " card"}>
        <CardBody className="p-t-5 p-b-5">
          <Col md={"6"}></Col>

          <Row>
            <Col lg="6">
              <FormGroup className={styles["add-video-formgroup"]}>
                <Label id="title" className="form-label">
                  {props.t("video_modale.label_title")}*
                </Label>
                <input
                  {...register("title")}
                  required
                  onChange={event => {
                    setValue("title", event.target.value);
                    handleIsFormValid(event.target.value);
                  }}
                  maxLength={100}
                  className="form-control"
                  type="text"
                  placeholder={props.t("video_modale.label_title")}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup className={styles["add-video-formgroup"]}>
                <Label id="date" className="form-label">
                  {props.t("video_modale.label_date")}*
                </Label>{" "}
                <br />
                <Controller
                  control={control}
                  name="dateSupport"
                  rules={{ required: true }}
                  render={({ field: { onChange } }) => (
                    <DatePicker
                      className="form-control"
                      selected={getValues("dateSupport") ? new Date(getValues("dateSupport")) : null}
                      onChange={(e: Date) => {
                        onChange(String(e?.getFullYear()));
                        handleIsFormValid(String(e?.getFullYear()));
                      }}
                      maxDate={new Date()}
                      placeholderText={props.t("video_modale.label_date")}
                      dateFormat="yyyy"
                      showYearPicker
                    />
                  )}
                />
              </FormGroup>
            </Col>
            <Col sm="12" md="6">
              <FormGroup className={styles["add-video-formgroup"]}>
                <Label id="document" className="form-label">
                  {props.t("video_modale.label_video_type")}*
                </Label>
                <Typeahead
                  id="document-typeahead"
                  clearButton
                  defaultSelected={props.support ? [props.support.videoType] : []}
                  labelKey={selectedLanguage === "en" ? "titleAnglais" : "titleFrancais"}
                  multiple={false}
                  inputProps={{ required: true }}
                  options={listOptionsVideo}
                  placeholder={props.t("video_modale.label_video_type")}
                  onChange={handleChangeDocument}
                  className={errors.title?.message ? styles["form-error"] : ""}
                  onInputChange={e => setError("title", { message: "valeur invalide" })}
                  onBlur={() => documentRef.current?.blur()}
                  ref={documentRef}
                />
              </FormGroup>
            </Col>
            <Col sm="12" md="6">
              <FormGroup className={styles["add-video-formgroup"]}>
                <Label id="langue" className="form-label">
                  {props.t("video_modale.label_language")}*
                </Label>
                <Typeahead
                  id="langue-typeahead"
                  clearButton
                  defaultSelected={props.support ? [props.support.language] : []}
                  labelKey={"name"}
                  multiple={false}
                  inputProps={{ required: true }}
                  options={listOptionsLanguage}
                  placeholder={props.t("video_modale.label_language")}
                  onChange={handleChangeLanguage}
                  className={errors.language?.message ? styles["form-error"] : ""}
                  onInputChange={e => setError("language", { message: "valeur invalide" })}
                  onBlur={() => langueRef.current?.blur()}
                  ref={langueRef}
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup className={styles["add-video-formgroup"]}>
                <Label id="thematic" className="form-label">
                  {props.t("video_modale.label_thematic")}*
                </Label>
                <Typeahead
                  id="thematic-typeahead"
                  defaultSelected={props.support ? props.support.listThematic : []}
                  labelKey={selectedLanguage === "en" ? "titleAnglais" : "titleFrancais"}
                  multiple={true}
                  options={listOptionsThematic}
                  placeholder={props.t("video_modale.label_thematic")}
                  onChange={handleChangeThematic}
                  className={errors.listThematic?.message ? styles["form-error"] : ""}
                  onInputChange={e => setError("listThematic", { message: "valeur invalide" })}
                  onBlur={() => thematicRef.current?.blur()}
                  ref={thematicRef}
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup className={styles["add-video-formgroup"]}>
                <Label id="country" className="form-label">
                  {props.t("video_modale.label_country")}*
                </Label>
                <Typeahead
                  id="country-typeahead"
                  defaultSelected={props.support ? props.support.listCountry : []}
                  labelKey={selectedLanguage === "en" ? "titleAnglais" : "titleFrancais"}
                  multiple={true}
                  options={listOptionsCountry}
                  placeholder={props.t("video_modale.label_country")}
                  onChange={handleChangeCountry}
                  className={errors.listCountry?.message ? styles["form-error"] : ""}
                  onInputChange={e => setError("listCountry", { message: "valeur invalide" })}
                  onBlur={() => countryRef.current?.blur()}
                  ref={countryRef}
                />
              </FormGroup>
            </Col>
          </Row>
          <ModalFooter className="m-t-30 p-b-0 p-t-5">
            <StepperActionButtons close={props.closeToggle} disable={!isFormValid} {...props} nextStep={validate} />
          </ModalFooter>
        </CardBody>
      </Form>
    </Fragment>
  );
};

export default translate(StepOne);
